import DealLLMContentSection from "components/cards/DealLLMContentSection";

const DealAiAssistant = ({ dealDetails }: any) => {
  return <DealLLMContentSection dealDetails={dealDetails} className="mb-3" />;
};

export default DealAiAssistant;
